<template>
  <div id="app">
    <!-- 顶部导航栏 -->
    <van-nav-bar v-if="showNavBar" :title="navTitle" :left-arrow="showLeftBack" @click-left="onClickLeft"
      @click-right="onClickRight">
    </van-nav-bar>
    <!-- 主要内容区域 -->
    <div class="main-content" :class="{ 'with-navbar': showNavBar, 'with-tabbar': showTabBar }">
      <router-view></router-view>
    </div>

    <!-- 底部标签栏 -->
    <van-tabbar route :border="false" v-if="showTabBar">
      <van-tabbar-item replace to="/" icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item replace to="/market" icon="search">市场</van-tabbar-item>

      <van-tabbar-item replace to="/stockOrBack" class="sell-button">
        <template #icon>
          <div class="circle-icon">
            <van-icon name="plus" size="24" />
          </div>
        </template>
        <span>出售</span>
      </van-tabbar-item>
      <van-tabbar-item replace to="/proxyPlay" icon="diamond-o">代充</van-tabbar-item>
      <van-tabbar-item replace to="/profile" icon="user-o">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      activeTab: 0,
      navTitle: '武器虚拟市场',
      showNavBar: true,
      showLeftBack: false,
      showTabBar: false,
      showLeftBackList: ['/backProcess', '/wallet', "/stock", '/proxyPlayHistory', '/message', '/weapon', '/paymentHistory', '/zijinHistory', '/myInfo', '/registermerchant', '/userauth', '/shopHistory', '/sellHistory', '/cart'],
      showTabbarList: ['/', '/proxyPlay', '/market', '/profile', '/stockOrBack'],
      hideNavBarList: ['/', '/profile', '/stockOrBack'],
      routeMappingNavTitle: {
        '/market': '武器市场',
        '/myInfo': '个人中心',
        '/registermerchant': '注册商户',
        '/back': '市场回收',
        '/backProcess': '我要回收',
        '/wallet': '我的钱包',
        '/stock': '上架武器',
        '/chat': '在线客服',
        '/proxyPlay': '游戏代充',
        '/proxyPlayHistory': '代充记录',
        '/message': '消息中心',
        '/weapon': '皮皮售交易市场',
        '/paymentHistory': '资金明细',
        '/zijinHistory': '交易记录',
        '/shopHistory': '购买记录',
        '/sellHistory': '售出记录',
        '/paypage': '充值金额',
        '/cart': '购物车',
        '/payment-result': '支付收银台'
      }
    }
  },
  watch: {
    '$route'(to) {
      const path = to.path.startsWith("/weapon") ? "/weapon" : to.path;
      console.log(path)
      this.navTitle = this.routeMappingNavTitle[path] || '武器市场';
      const hideNavBarIndex = this.hideNavBarList.indexOf(path);
      if (hideNavBarIndex != -1) {
        this.showNavBar = false;
      } else {
        this.showNavBar = true;
        const showLeftBackIndex = this.showLeftBackList.indexOf(path);
        if (showLeftBackIndex != -1) {
          this.showLeftBack = true
        } else {
          this.showLeftBack = false
        }
      }
      const showTabbarIndex = this.showTabbarList.indexOf(path);
      if (showTabbarIndex != -1) {
        this.showTabBar = true;
      } else {
        this.showTabBar = false;
      }
      console.log("showNavBar:", this.showNavBar)
      console.log("showLeftBack:", this.showLeftBack)
      console.log("showTabBar:", this.showTabBar)
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    onClickRight() {
      // 搜索功能
      console.log('搜索')
    },
    onTabChange(index) {
      this.activeTab = index
    }
  }
}
</script>

<style>
#app {
  height: 100%;
  background-color: #f7f8fa;
  overflow: hidden;
}

.main-content {
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.main-content.with-navbar {
  padding-top: 0;
}

.main-content.with-tabbar {
  padding-bottom: 50px;
}

.main-content.with-navbar.with-tabbar {
  padding-top: 0;
}

.height-50 {
  height: 50px !important;
}

.circle-icon {
  width: 32px;
  height: 32px;
  background-color: #ee0a24;
  margin-top: -3px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: #fff;
  transform: translateY(-8px);
  box-shadow: 0 2px 8px rgba(238, 10, 36, 0.3);
}

.icon-text {
  font-size: 14px;
  font-weight: 500;
}

.sell-button {
  margin-top: -10px;
}

:deep(.van-tabbar-item__icon) {
  margin-bottom: 0;
}
</style>
